import ReactDOM from 'react-dom';
import axios from 'axios';

export const DownloadImage = ({ icon = null }) => {
	// https://stackoverflow.com/questions/58131035/download-file-from-the-server-laravel-and-reactjs
	const handleClick = (e) => {
		e.preventDefault();

		const imageUrl = e.currentTarget.parentNode.getAttribute('data-downimage');
		let imageName = imageUrl.split("/").pop();

		if (imageName.indexOf("?") >= 0)
			imageName = imageName.substring(0, imageName.indexOf('?'));

		const params = {
			"imageUrl": imageUrl,
		}

		axios({
			url: '/download-image',
			method: 'post',
			data: params,
			responseType: 'arraybuffer',
		})
			.then(function (response) {
				let blob = new Blob([response.data], { type: 'application/jpg' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = imageName;
				link.click();
			})
			.catch(error => {
				console.log(error)
			});
	}

	return (
		<a href="#" onClick={handleClick}>
			{
				icon ?
					<img src={icon} alt="download-icon" width={24} height={24} className="download-image-icon"/> :
					'Download Image'
			}
		</a>
	);
}